export default __webpack_public_path__ + "static/media/hongloan.96ca7d6f.png";